<div class="account-layout">
  <div class="account-lang">
    <button
      type="button"
      nz-button
      nzType="text"
      nz-dropdown
      nzTrigger="click"
      [nzDropdownMenu]="languageMenu"
      class="account-lang-trigger"
      [attr.aria-label]="'account.auth.language' | transloco"
    >
      <span nz-icon nzType="translation"></span>
      <span class="account-lang-label">{{ activeLanguageLabel() }}</span>
    </button>
    <nz-dropdown-menu #languageMenu="nzDropdownMenu">
      <ul nz-menu nzSelectable>
        @for (option of languageOptions; track option.value) {
          <li
            nz-menu-item
            [nzSelected]="activeLanguage() === option.value"
            (click)="onSwitchLanguage(option.value)"
          >
            {{ option.label }}
          </li>
        }
      </ul>
    </nz-dropdown-menu>
  </div>

  <div class="account-content">
    <div class="account-panel">
      <div class="account-brand">
        <img
          class="account-brand-logo"
          src="assets/logo/mp_logo_300_300.png"
          width="48"
          height="48"
          alt=""
        />
        <div class="account-brand-text">
          <h1 class="account-brand-name">{{ 'account.auth.brand' | transloco }}</h1>
        </div>
      </div>

      <div class="account-outlet">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
